import qs from 'qs';

const CASE_STUDY_INDUSTRY_FIELDS = {
  INDUSTRY_NAME: 'industryName',
  INDUSTRY_NAME_COLOR: 'industryNameColor',
  CATEGORY_GRADIENT_COLOR: 'categoryGradientColor',
}

export const getAllCaseStudyIndustryQs = qs.stringify({
  fields: [CASE_STUDY_INDUSTRY_FIELDS.INDUSTRY_NAME],
  populate: {
    industryIcon: {
      fields: ['alternativeText', 'url']
    },
    industryIconWhite: {
      fields: ['alternativeText', 'url']
    }
  }
}, { encodeValuesOnly: true })


export const getCaseStudyIndustryQs = (industryName) => {
  return qs.stringify({
    filters: {
      industryName: {
        $eq: industryName
      }
    },

    fields: [CASE_STUDY_INDUSTRY_FIELDS.INDUSTRY_NAME, CASE_STUDY_INDUSTRY_FIELDS.INDUSTRY_NAME_COLOR, CASE_STUDY_INDUSTRY_FIELDS.CATEGORY_GRADIENT_COLOR]

  }, { encodeValuesOnly: true })
}


const CASE_STUDY_FIELDS = {
  TITLE: 'title',
  SUMMARY: 'summary',
  SLUG: 'slug',
  COVER_IMAGE: 'coverImage',
  SHORT_TITLE: 'shortTitle',
  UPDATED_AT: 'updatedAt',
  CREATED_AT: 'createdAt',
}


export const getCaseStudyFromIndustryQs = (industryName, versionType) => {
  return qs.stringify({
    filters: {
      caseStudyIndustry: {
        industryName: {
          $eq: industryName
        }
      },
      cipVersion: {
        versionType: {
          $in: [versionType]
        }
      }
    },
    sort: [`${CASE_STUDY_FIELDS.UPDATED_AT}:desc`],
    fields: [CASE_STUDY_FIELDS.TITLE, CASE_STUDY_FIELDS.SHORT_TITLE, CASE_STUDY_FIELDS.SLUG, CASE_STUDY_FIELDS.SUMMARY, CASE_STUDY_FIELDS.UPDATED_AT],
    populate: {
      [CASE_STUDY_FIELDS.COVER_IMAGE]: {
        fields: ['alternativeText', 'url', 'caption']
      }
    }
  }, { encodeValuesOnly: true })
}


export const getReadMoreCaseStudyFromIndustryAndSlugQs = (industryName, slug, versionType) => {
  return qs.stringify({
    filters: {
      caseStudyIndustry: {
        industryName: {
          $eq: industryName
        }
      },
      slug: { $ne: slug },
      cipVersion: {
        versionType: {
          $in: [versionType]
        }
      }
    },
    fields: [CASE_STUDY_FIELDS.TITLE, CASE_STUDY_FIELDS.SLUG]
  }, { encodeValuesOnly: true })
}


export const getCaseStudyFromSlugQs = (slug, versionType, industryName) => {
  return qs.stringify({
    filters: {
      caseStudyIndustry: {
        industryName: {
          $eq: industryName
        }
      },
      slug: {
        $eq: slug
      },
      cipVersion: {
        versionType: {
          $in: [versionType]
        }
      }
    },
    populate: 'deep'
  }, { encodeValuesOnly: true })
}


export const PREVIOUS_CASE_STUDY = 'prev'
export const NEXT_CASE_STUDY = 'next'

export const getPrevNextCaseStudyQs = (createdAt, prevOrNext = PREVIOUS_CASE_STUDY, versionType, industryName) => {

  let createdAtFilter = {
    $lt: createdAt
  }
  let createdAtSortOrder = 'desc'

  if (prevOrNext === NEXT_CASE_STUDY) {
    createdAtFilter = { $gt: createdAt }
    createdAtSortOrder = 'asc'
  }

  return qs.stringify({
    filters: {
      caseStudyIndustry: {
        industryName: {
          $eq: industryName
        }
      },
      createdAt: createdAtFilter,
      cipVersion: {
        versionType: {
          $in: [versionType]
        }
      }
    },
    fields: [CASE_STUDY_FIELDS.SLUG],
    sort: [`${CASE_STUDY_FIELDS.CREATED_AT}:${createdAtSortOrder}`],
    pagination: {
      limit: 1
    }
  }, { encodeValuesOnly: true })
}